import React from "react";
export const BasketTabIcon = (): JSX.Element => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="basketTabIcon"
    >
      <path
        d="M18.9243 9H5.07573C4.41135 9 3.93169 9.63591 4.11421 10.2747L5.92111 16.5989C6.41174 18.3161 7.98128 19.5 9.76721 19.5H14.2328C16.0187 19.5 17.5883 18.3161 18.0789 16.5989L19.8858 10.2747C20.0683 9.6359 19.5886 9 18.9243 9Z"
        stroke="#020305"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <path
        d="M15.7395 9H8.26051C7.54417 9 7.06016 8.2689 7.33993 7.60945L7.62487 6.9378C8.25188 5.45986 9.70176 4.5 11.3072 4.5H12.6928C14.2982 4.5 15.7481 5.45986 16.3751 6.9378L16.6601 7.60945C16.9398 8.2689 16.4558 9 15.7395 9Z"
        stroke="#020305"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  );
};
